"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 58915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionOpenPositions": function() { return /* binding */ SectionOpenPositions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46115);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61349);





const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    backgroundColor: "$darkThemeBackground",
    color: "$white",
    variants: {
        isSingleCardCard: {
            true: {
                paddingInline: "$20"
            }
        }
    }
});
const Content = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$30",
    margin: "0 auto",
    containerSpace: "medium",
    width: "100%",
    marginBottom: "$64"
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    projectFont: "heading02",
    textAlign: "center",
    padding: "0 $20"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "heading07",
    textAlign: "center",
    color: "$gray300",
    margin: "0 auto",
    maxWidth: "750px"
});
const CardWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    padding: "$20",
    backgroundColor: "$techstackCardsBackground",
    borderRadius: "$r3",
    width: "100%",
    margin: "0 auto",
    display: "grid",
    gap: "$40",
    "@md": {
        padding: "$30"
    },
    variants: {
        isSingleCard: {
            true: {
                padding: "$20",
                maxWidth: "920px",
                gridTemplateRows: "1fr 1fr",
                gridTemplateColumns: "1fr",
                "@md": {
                    gridTemplateColumns: "2fr 1fr",
                    gridTemplateRows: "1fr"
                }
            }
        }
    }
});
const CardContentWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridTemplateRows: "auto 1fr",
    gap: "$40",
    variants: {
        isSingleCard: {
            true: {
                minWidth: "280px"
            }
        }
    }
});
const UpperContent = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridAutoFlow: "row",
    gap: "$32"
});
const CardTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "heading07",
    fontSize: "24px"
});
const CardDescription = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "heading08",
    color: "$white_07"
});
const ImageWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    borderRadius: "$r2",
    overflow: "hidden"
});
const Pills = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    listStyleType: "none",
    gap: "$8"
});
const StyledLink = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
    display: "flex",
    alignSelf: "flex-end",
    width: "fit-content",
    gap: "$8"
});
const Card = (param)=>{
    let { _key , title , description , tags , image , ctaLink , isSingleCard =false  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("contact");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardWrapper, {
        isSingleCard: isSingleCard,
        children: [
            isSingleCard && image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                    ...image,
                    layout: "fill"
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardContentWrapper, {
                isSingleCard: isSingleCard,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UpperContent, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardDescription, {
                                children: description
                            }),
                            (tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pills, {
                                children: tags === null || tags === void 0 ? void 0 : tags.map((tag)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .DR, {
                                        appearance: "UI06Uppercase",
                                        children: tag
                                    }, "".concat(_key, "-").concat(tag)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledLink, {
                        ...ctaLink,
                        appearance: "containedTransparent",
                        children: [
                            t("applyNow"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_3__/* .Arrow */ .Eh, {})
                        ]
                    })
                ]
            })
        ]
    });
};
const SectionOpenPositions = (param)=>{
    let { title , description , anchorId , positions , spacing , topBorder  } = param;
    if (!(positions === null || positions === void 0 ? void 0 : positions.length)) return null;
    const isSingleCardPosition = (positions === null || positions === void 0 ? void 0 : positions.length) === 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        id: anchorId,
        type: spacing || "MEDIUM",
        isSingleCardCard: isSingleCardPosition,
        topBorder: topBorder,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Content, {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {
                        children: description
                    })
                ]
            }),
            isSingleCardPosition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                ...positions[0],
                isSingleCard: true
            }, positions[0]._key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Slider */ .iR, {
                children: positions === null || positions === void 0 ? void 0 : positions.map((position)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                        ...position
                    }, position._key))
            })
        ]
    });
};


/***/ })

}]);